import manifest from '../../web-articles/manifest.json';
const WEB_ORIGIN = 'https://web.staircrusher.club';
export const ARTICLES_LIST_URL = `${WEB_ORIGIN}/articles`;
export const ARTICLE_AUTHOR = '계단뿌셔클럽';
const MANIFEST = manifest;
// 웹 목록 페이지와 **같은** comparator (scripts/build-articles.js reassembleDist).
// 홈 상위 3개 = web.staircrusher.club/articles 상단 3개가 되도록 일부러 일치시킨다.
const rank = (a) => typeof a.featured === 'number' ? a.featured : Infinity;
const pub = (a) => a.publishedAt || a.createdTime || '';
// scripts/article-template.js fmtDate와 동일 규칙.
const formatDate = (iso) => (iso || '').slice(0, 10).replace(/-/g, '.');
export function selectArticles(entries, count) {
    return entries
        .filter(entry => !entry.parent)
        .sort((a, b) => rank(a) - rank(b) || pub(b).localeCompare(pub(a)))
        .slice(0, count)
        .map(entry => {
        var _a;
        return ({
            slug: entry.slug,
            title: entry.title,
            imageUrl: `${WEB_ORIGIN}${(_a = entry.thumbnail) !== null && _a !== void 0 ? _a : entry.image}`,
            dateLabel: formatDate(entry.publishedAt),
            url: entry.linkUrl || `${WEB_ORIGIN}/articles/${entry.slug}`,
        });
    });
}
export function getLatestArticles(count) {
    return selectArticles(Object.values(MANIFEST), count);
}
